import React, { useContext, useState, useEffect, useLayoutEffect, useRef } from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import PaineisContext from "../../../contexts/Paineis"
import ContentBlank from "../../molecules/ContentBlank"
import { Tab } from "../../molecules/SelectTabs"
import RcmpBackPageButton from "../../atoms/BackPageButton"
import DocumentReadyIcon from "../../../assets/icons/DocumentReadyIcon"
import EditIcon from "../../../assets/icons/EditIcon"
import MoveIcon from "../../../assets/icons/MoveIcon"
import TrashIcon from "../../../assets/icons/TrashIcon"
import RcmpEmptyContentPage from "../../molecules/EmptyContentPage"
import noBlocksImage from "../../../assets/img/no-blocks-illustration.svg"
import RcmpModalAddBlock from "../../organisms/ModalAddBlock/Index"
import {
  fnCreateBlock,
  fnListBlocks,
  fnDeleteBlocks,
  fnEditBlock,
  fnMoveBlock,
  fnHiddenBlockFields,
} from "../../../services/blocks"
import useDataApi from "../../../hooks/useDataApi"
import RcmpBlocksList from "../../molecules/BlocksList"
import RcmpLoading from "../../atoms/Loading"
import RcmpModalInfo from "../../organisms/ModalInfo"
import ModalConfirmDelete from "../../organisms/ModalAddPainelCancel"
import RcmpModalMove from "../../molecules/ModalMove"
import { getPaineis, fnGetPainelBoard } from "../../../services/paineis"
import RcmpAccordionSubItem from "../../atoms/AcordionSubItem"
import RcmpModalAddActivity from "../../organisms/ModalAddActivity"
import RcmpAccordion from "../../atoms/Accordion"
import {
  fnCreateActivity,
  fnUpdateActivity,
  fnMoveActivities,
  fnReorderActivities,
  fnDeleteActivity,
  fnGetActivityDetails,
} from "../../../services/acitivities"
import AuthContext from "../../../contexts/Auth"
import { fnIsObserver, fnIsResponsible } from "../../../utils/permissions"
import {
  fnDeleteBoard,
  fnDuplicateBoard,
  fnExportBoard,
  fnGetBoard,
  fnMoveBoard,
  fnUpdateBoard,
  fnUpdateOrderBlocks,
} from "../../../services/boards"
import RcmpModalCreateNewCustomField from "../../molecules/ModalCreateNewCustomField"
import {
  fnGetEvidences,
  fnStoreEvidence,
  fnEditTextEvidence,
} from "../../../services/evidences"
import {
  fnCreateActivityField,
  fnUpdateField as fnUpdateFields,
} from "../../../services/activityFields"
import {
  fnStoreComent,
  fnDeleteComent,
  fnUpdateComent,
  fnListComments,
} from "../../../services/comments"
import RcmpModalsBoardChange from "../../organisms/ModalsBoardsChange/RcmpModalsBoardsChange"
import StatesOfModals from "../../../contexts/StatesOfModals"
import FieldsContext from "../../../contexts/Fields"
import RcmpHeader from "../../atoms/Header"
import { cStatusSlug, cTitleSlug } from "../../../constans/activity-slugs"
import BoardContext from "../../../contexts/Board"
import { DragDropContextProvider } from "../../../contexts/DragAndDropContext"
import GearIcon from "../../../assets/icons/GearIcon"
import RcmpModalActivityModel from "../../organisms/ModalActivityModel"
import useCheckSubmitRegister from "../../../hooks/useCheckSubmitRegister"
import { searchHighlight } from "../../../utils/search"
import PenDocumentIcon from "../../../assets/icons/PenDocument"
import RcmpAutomationIcon from "../../../assets/icons/AutomationIcon"
import RcmpModalList from "../../organisms/ModalList"
import { BlocksContext } from "../../../contexts/Blocks"
import Button from "../../atoms/Button"
import OrderIcon from "../../../assets/icons/OrderIcon"
import { toast } from "@stardust-ds/react"
import ExportIcon from "../../../assets/icons/ExportIcon"
import RcmpModalExport from "../../organisms/ModalExport"
import { fnHidenTutorialModal, fnShowTutorialModal } from "../../../services/forms"
import { fnFormList } from "../../../services/forms"
import FormContext from "../../../contexts/Form"
import { fnHandleExportToPdf, fnHandleExportToXlsx } from "../../../utils/export"
import RcmpModalNewForm from "../../organisms/ModalNewForm"
import RcmpTutorialModal from "../../organisms/TutorialModal"
import RcmpModalNewAutomation from "../../organisms/ModalNewAutomation"
import automationContext from "../../../contexts/Automation"
import {
  fnChangeShowAutomationTutorial,
  fnShowAutomationTutorial,
} from "../../../services/automation"
import { FilterContext } from "../../../contexts/Filter"
import CopyIcon from "../../../assets/icons/CopyIcon"
import { fnGetCustLogo } from "../../../services/reports"
import RcmpModalHideFields from "../../organisms/ModalHideFields"
import { fnGeStatusLogin } from "../../../services/auth"
import { fnDecodeStorageToken } from "../../../utils/encodeLocalStorage"
import { BrandTitle } from "../../../contexts/Appearance"

let aBoardsToShow

export default function BlocksPage(props) {
  const { newBoard } = props
  const fnNavigate = useNavigate()
  const { oUser } = useContext(AuthContext)
  const nUserId = oUser?.data?.user_nid
  const {
    bIsOpenModalEditBoard,
    fnCloseModalEditBoard,
    fnOpenModalAlertDeleteBoard,
    fnOpenModalDeleteBoard,
    fnCloseModalDeleteBoard,
    bIsOpenModalDeleteBoard,
    bIsOpenModalDeleteBoardAlert,
    bIsOpenModalInteractionsBoard,
    fnSetBIsOpenModalInteractionsBoard,
    bIsOpenModalMoveBoard,
    fnSetIsOpenModalMoveBoard,
    bIsOpenModalMoveAlertBoard,
    closeModalMoveAlert,
    fnGetNormsSubmit,
    fnOpenModalEditBoard,
    fnHandleModalMoveAlert,
    aNorms,
    schema,
  } = useContext(StatesOfModals)

  const [oGetResponsiblesBoard, fnSubmitGetResponsiblesBoard] = useDataApi(fnGetBoard)
  const [oGetBoardExportRes, fnGetBoardExportReq] = useDataApi(fnExportBoard)
  const [oGetCustomerLogoRes, fnGetCustomerLogoReq] = useDataApi(fnGetCustLogo)
  const {
    oCurrentBoard,
    fnSetOCurrentBoard,
    fnGetCurrentBoard,
    oBoardRes,
    fnRefreshCurrentBoard,
    fnUpdateBoardModel,
  } = useContext(BoardContext)
  const userId = oUser?.data?.user_nid
  const bUserIsAdmin = oUser?.data?.bIsAdmin

  const [bCanChange, fnSetCanChange] = useState(false)

  useEffect(() => {
    if (!userId || !oCurrentBoard) return
    fnSetCanChange(oCurrentBoard?.bIsResponsible || bUserIsAdmin)
    fnSetBIsResponsibleCurrentActivity(oCurrentBoard?.bIsResponsible || bUserIsAdmin)
  }, [oCurrentBoard, oUser])

  const bIsObserver = fnIsObserver(
    nUserId,
    oGetResponsiblesBoard?.data?.data?.data[0]?.observers,
  )
  let aCardOptions = [
    {
      label: intl.get("board.edit_board"),
      icon: <EditIcon width="25" height="22" />,
      onClick: () => fetchBordData(nBoardId),
    },
    {
      label: intl.get("CardBoard.duplicate_board"),
      icon: <CopyIcon fill={"none"} className={styles.duplicateIcon} />,
      onClick: fnOpenModalDuplicateBoard,
    },
    {
      label: intl.get("board.interactions"),
      icon: <DocumentReadyIcon width={26} height={22} />,
      onClick: () => fnSetBIsOpenModalInteractionsBoard(true),
    },
    {
      label: intl.get("BlocksPage.sort_blokcs"),
      icon: <OrderIcon />,
      onClick: fnHandleOnClickSortBlocks,
    },
    {
      label: intl.get("board.move_board"),
      icon: <MoveIcon width="25" height="22" />,
      onClick: fnHandleModalMoveBoardOpen,
    },
    {
      label: intl.get("board.delete_board"),
      icon: <TrashIcon width="22" height="25" />,
      onClick: () => fnOpenModalAlertDeleteBoard({ id: nBoardId }),
    },
    {
      label: "Exportar",
      icon: <ExportIcon />,
      onClick: fnToggleExportModalIsOpen /* fnHandleExportToPdf */,
    },
  ]

  if (!bCanChange) {
    const optionsToRemove = [
      intl.get("board.edit_board"),
      intl.get("board.delete_board"),
      intl.get("board.move_board"),
      intl.get("board.activity_model"),
    ]
    aCardOptions = aCardOptions.filter(
      (option) => !optionsToRemove.includes(option.label),
    )
  }

  const location = useLocation()
  const {
    panelId,
    boardId: nBoardId,
    blockId: nBlockId,
    activityId: nActivityId,
  } = useParams()

  const [bModalIsOpen, fnSetBModalIsOpen] = useState(false)
  const [bCalcModelError, fnSetBCalModalError] = useState(false)
  const [bModalCantExportIsOpen, fnSetBModalCantExportIsOpen] = useState(false)
  const [oOpenModalErrorQrCode, fnSetOOpenModalErrorQrCode] = useState({
    bIsOpen: false,
    blockType: "",
  })
  const [bModalModelActivityIsOpen, fnSetBModalModelActivityIsOpen] = useState(false)
  const [bModalExportActivityIsOpen, fnSetBModalExportActivityIsOpen] = useState(false)
  const [bIsFormManager, fnSetBIsFormMager] = useState(false)

  const {
    ofnCreateNewFormRes,
    bUpdateFormList,
    fnSetBUpdateFormList,
    ofnUpdateFormRes,
    bIsEditForm,
    bOpenNewForm,
    fnOpenNewForm,
    bShareForm,
    oForm,
    fnCloseNewForm,
  } = useContext(FormContext)
  const {
    fnOpenNewAutomation,
    bOpenNewAutomation,
    fnCloseNewAutomation,
    oNewAutomationRes,
    oAutomationList,
    fnAutomationListReq,
    oUpdateAutomationRes,
    oListAutomationRes,
    bShareAutomation,
    oChangeInactiveAutomationRes,

    fnAutomationHistoryReq,
    bUpdatedAutomationList,
  } = useContext(automationContext)

  const { aAllFields, fnGetFields } = useContext(FieldsContext)
  const { oCurrentPanel, fnGetCurrentPanel } = useContext(PaineisContext)

  const [aEvidences, fnSetAEvidences] = useState([])
  const [aComments, fnSetAComments] = useState([])

  const [bIsDelete, fnSetBIsDelete] = useState(false)
  const [bIsDeleteActivity, fnSetBIsDeleteActivity] = useState(false)
  const [bIsDeleteConfirmation, fnSetBIsDeleteConfirmation] = useState(false)
  const [bIsDeleteConfirmationActivity, fnSetBIsDeleteConfirmationActivity] =
    useState(false)
  const [oBoardDataMove, fnSetOBoardDataMove] = useState({})

  const [aBoardData, fnSetABoadData] = useState([])
  const [oBlock, fnSetOBlock] = useState({})
  const [bIsEdit, fnSetBisEdit] = useState(false)
  const [bIsMove, fnSetBisMove] = useState(false)
  const [bIsMoveActivities, fnSetBIsMoveActivities] = useState(false)
  const [nNewBlockMoveId, fnSetNNewBlockMoveId] = useState(-1)
  const [oBlockData, fnSetOBlockData] = useState({})
  const [bOpenActivyModal, fnSetBOpenActivyModal] = useState(false)
  const [bOpenModalList, fnSetBOpenModalList] = useState(false)
  const [bWasOpenActivyModal, fnSetBWasOpenActivyModal] = useState(false)
  const [bIsEditActivity, fnSetBIsEditActivity] = useState()
  const [bIsVisibleFieldsTable, fnSetBIsVisibleFieldsTable] = useState(false)
  const [oCurrentBlock, fnSetOCurrentBlock] = useState([])
  const [oCurrentActivity, fnSetOcurrentActivity] = useState(null)
  const [nCurrentActivityMove, fnSetNcurrentActivityMove] = useState(-1)
  const [bOpenCustomFields, fnSetBopenCustomFields] = useState(false)
  const [nBlockViewMode, fnSetnBlockViewMode] = useState()
  const [oShowFormTutorial, fnSetBShowFormTutorial] = useDataApi(fnShowTutorialModal)
  const [oShowAutomatuionTutorialRes, fnShowAutomationTutorialReq] = useDataApi(
    fnShowAutomationTutorial,
  )
  const [oHidenAutomationTutorialRes, fnSetBHidenAutomationTutorialReq] = useDataApi(
    fnChangeShowAutomationTutorial,
  )
  const [bIsOpenModalTutorial, fnSetBIsOpenModalTutorial] = useState(false)
  const [bVisualizedTutorialModal, fnSetBVisualizedTutorialModal] = useState("")
  const [aForms, fnSetAForms] = useState([])
  const [aAutomation, fnSetAAutomation] = useState([])
  const [cBoardName, fnSetCBoardName] = useState(
    location?.state?.cBoardName || oCurrentBoard?.name,
  )
  const [bIsOpenModalNewCustomField, fnSetBIsOpenModalNewCustomField] = useState(false)
  const [bOpeEditCustomField, fnSetBOpeEditCustomField] = useState(false)
  const [oCustomField, fnSetOCustomField] = useState()
  const [bSortBlocks, fnSetSortBlocks] = useState(false)
  const [bIsOpenModalDuplicate, fnSetBIsOpenModalDuplicate] = useState(false)
  const [oCreateBlock, fnOCreateBlock] = useDataApi(fnCreateBlock)
  const [oHiddentTutorialModal, fnSetHiddentTutorialModal] =
    useDataApi(fnHidenTutorialModal)
  const [oOrderBlockRes, fnOOrderBlockReq] = useDataApi(fnUpdateOrderBlocks)
  const {
    aBlocks,
    fnSetABlocks,
    fetchBlocksWithParams,
    oParams,
    fnSetOparams,
    aBlocksASortedOrder,
    fnFetchActivitiesByBlock,
    fnFetchBlocksToOrder,
    oListBlocksPagination,
    aBlocksToOrder,
  } = useContext(BlocksContext)
  const { fnChangeCostumerReq } = useContext(AuthContext)

  const [oListBlocksAccordion, fnOListBlocksAccordion] = useDataApi(fnListBlocks)
  const [oBoard, fnFetchBoard] = useDataApi(fnGetBoard)
  const [oDeleteBlocks, fnODeleteBlocks] = useDataApi(fnDeleteBlocks)
  const [oUpdateBlocks, fnOUpdateBlocks] = useDataApi(fnEditBlock)
  const [oMoveBlocks, fnOMoveBlocks] = useDataApi(fnMoveBlock)
  const [oGetEvidenceList, fnOGetEvidenceList] = useDataApi(fnGetEvidences)
  const [oMoveActivity, fnOMoveActivity] = useDataApi(fnMoveActivities)
  const [oGetPaineis, fnSubmitGetPaineis] = useDataApi(getPaineis)

  const [oGetPainel, fnSubmitGetPainel] = useDataApi(fnGetPainelBoard)
  const [oCreateActivityRes, fnCreateActivityReq] = useDataApi(fnCreateActivity)
  const [oUpdateActivityRes, fnUpdateActivityReq] = useDataApi(fnUpdateActivity)
  const [oReorderActivitiesRes, fnReorderActivitiesReq] = useDataApi(fnReorderActivities)
  const [oDeleteActivityRes, fnDeleteActivityReq] = useDataApi(fnDeleteActivity)
  const [oSubmitEvidence, fnSubmitEvidenceReq, fnResetEvidenceRes] =
    useDataApi(fnStoreEvidence)
  const [oSubmitEditEvidence, fnSubmitEditEvidenceReq] = useDataApi(fnEditTextEvidence)

  const [oChangeVisibilityFieldsRes, fnChangeVisibilityFieldsReq] =
    useDataApi(fnHiddenBlockFields)
  const [oCreateCommentRes, fnCreateCommentReq] = useDataApi(fnStoreComent)
  const [oDeleteCommentRes, fnDeleteCommentReq] = useDataApi(fnDeleteComent)
  const [oCreateActivityFieldRes, fnCreateActivityFielReq] =
    useDataApi(fnCreateActivityField)
  const [oUpadteCommentRes, fnUpadteCommentReq] = useDataApi(fnUpdateComent)
  const [oGetActivitiesRes, fnGetActivitiesReq] = useDataApi(fnGetActivityDetails)
  const [oGetCommentsRes, fnGetCommentsReq] = useDataApi(fnListComments)
  const [oUpdateBoard, fnSubmitUpdateBoard] = useDataApi(fnUpdateBoard)
  const [oDeleteBoard, fnSubmitDeleteBoard] = useDataApi(fnDeleteBoard)
  const [oMoveBoard, fnSubmitMoveBoard] = useDataApi(fnMoveBoard)
  const [oFormsList, fnSubmitFormsList, fnFormListReset] = useDataApi(fnFormList)
  const [oGetStatusLoginRes, fnGetStatusLoginReq] = useDataApi(fnGeStatusLogin)
  const [oDuplicateBoardRes, fnSubmitDuplicateBoardReq] = useDataApi(fnDuplicateBoard)
  const [aCheckedFields, fnSetACheckedFields] = useState([])
  const [bIsResponsibleCurrentActivity, fnSetBIsResponsibleCurrentActivity] =
    useState(bCanChange)
  const [aCardOptionsFiltered, fnSetACardOptionsFiltered] = useState(aCardOptions)
  const [bIsQrCodeActivity, fnSetBIsQrCodeActivity] = useState(
    !nBlockId || newBoard ? false : true,
  )
  const { aFilters } = useContext(FilterContext)
  const [oUpdateFieldRes, fnUpdateField] = useDataApi(fnUpdateFields)

  const fnToPanelPage = () => fnNavigate(`/${panelId}/boards`)
  const painelRef = useRef(null)

  const [fnCheckRegister] = useCheckSubmitRegister()
  useEffect(() => {
    if (!nBlockId) return
    if (!nActivityId) return
    if (!userId) return
    ;(async () => {
      return await fnGetActivityModal(nBlockId, nActivityId, userId)
    })()
  }, [nActivityId, userId])

  const isQrCodeActivityModalMounted = useRef(false)
  useEffect(() => {
    if (
      !aBlocks.length ||
      oGetStatusLoginRes.loading ||
      bOpenActivyModal ||
      oOpenModalErrorQrCode.bIsOpen ||
      !nBlockId ||
      !aAllFields?.length ||
      isQrCodeActivityModalMounted.current ||
      !oUser?.data ||
      newBoard
    )
      return
    ;(async () => {
      fnSetBIsQrCodeActivity(true)
      const currentBlock = aBlocks.find((block) => {
        if (block.opbl_nid === Number(nBlockId)) return block
        return
      })
      isQrCodeActivityModalMounted.current = true
      const nCustId = fnDecodeStorageToken()?.nCustId
      await fnGetStatusLoginReq()

      const response = await fnChangeCostumerReq(nCustId)
      const bHasModule = ["access-operationalpanel", "operational-panel"].some(
        (permission) => oUser.data?.permission?.includes(permission),
      )
      if (!bHasModule && !oUser.data?.bIsAdmin) {
        //validation can access module
        return fnSetOOpenModalErrorQrCode({ bIsOpen: true, blockType: "denied_module" })
      }
      if (!bCanChange && !oUser.data?.bIsAdmin) {
        //  validation can access board
        return fnSetOOpenModalErrorQrCode({ bIsOpen: true, blockType: "denied_access" })
      }
      if (
        nBlockId &&
        nUserId &&
        response.cStorageToken &&
        bHasModule &&
        (oCurrentBoard?.bIsResponsible || oUser.data?.bIsAdmin)
      ) {
        fnSetBIsQrCodeActivity(false)
        fnHandleOpenActivityModal(currentBlock)
      }
    })()
  }, [
    nBlockId,
    nUserId,
    oGetStatusLoginRes,
    location.pathname,
    aBlocks,
    aAllFields,
    oUser,
    newBoard,
  ])
  useEffect(() => {
    if (!oCurrentActivity) return

    const bIsResponsible = fnIsResponsible(nUserId, oCurrentActivity.responsibles)
    fnSetBIsResponsibleCurrentActivity(bIsResponsible || bCanChange)
  }, [oCurrentActivity, bCanChange])

  const fnGetActivityModal = async (nBlockId, nActivityId, userId) => {
    const resp = await fnSubmitGetActivities(nActivityId)
    const activity = resp?.data
    const bIsactivityResponsible = fnIsResponsible(userId, activity.responsibles)
    const bIsPanelResponsible = fnIsResponsible(userId, oCurrentPanel?.responsibles)
    const aPermission = [bCanChange, bIsactivityResponsible, bIsPanelResponsible]

    if (!aPermission.includes(true)) return

    fnHandleModalEditActivitiesOpen(activity, resp)
  }

  useEffect(() => {
    if (aCardOptionsFiltered.length > 6) return
    if (aBlocks && aBlocks?.length > 0) {
      fnSetACardOptionsFiltered([
        ...aCardOptionsFiltered.slice(0, 2),
        {
          label: intl.get("board.automation"),
          icon: <RcmpAutomationIcon scale={"1.6"} />,
          onClick: () => fnOpenModalAutomationManagement(),
        },
        {
          label: intl.get("board.forms"),
          icon: <PenDocumentIcon width="25" />,
          onClick: () => fnOpenModalFormManagement(),
        },
        ...aCardOptionsFiltered.slice(2),
      ])
      return
    }
    fnSetACardOptionsFiltered(aCardOptions)
  }, [aBlocks])

  async function fetchBordData(id) {
    const response = await fnFetchBoard(panelId, id)
    await fnSetABoadData(response?.data?.data)
    await fnGetNormsSubmit()
    aBoardData && fnOpenModalEditBoard()
  }

  async function fnHandleModalMoveBoardOpen() {
    const response = await fnSubmitGetPaineis("perPage=200")
    response.success && fnSetIsOpenModalMoveBoard(true)
  }

  function fnToggleExportModalIsOpen() {
    fnSetBModalExportActivityIsOpen((prev) => !prev)
  }
  useEffect(() => {
    ;(async () => {
      await fnGetCurrentBoard(panelId, nBoardId)
      const response = await fnSubmitFormsList(nBoardId)
      fnSetAForms(response?.data)
    })()
  }, [panelId, nBoardId, ofnCreateNewFormRes, ofnUpdateFormRes])

  useEffect(() => {
    if (
      !nBoardId ||
      oFormsList.loading ||
      oFormsList.done ||
      bIsFormManager ||
      !bOpenModalList
    )
      return
    ;(async () => {
      const response = await fnSubmitFormsList(nBoardId)
      fnSetAForms(response?.data)
    })()
  }, [panelId, nBoardId, oFormsList, bIsFormManager, bOpenModalList])

  useEffect(() => {
    if (!bOpenModalList || !bIsFormManager) return
    ;(async () => {
      const response = await fnAutomationListReq(nBoardId)
      fnSetAAutomation(response?.data)
    })()
  }, [
    panelId,
    nBoardId,
    oNewAutomationRes,
    oUpdateAutomationRes,
    bUpdatedAutomationList,
    oChangeInactiveAutomationRes,
    bOpenModalList,
    fnCloseNewForm,
    bIsFormManager,
  ])

  useEffect(() => {
    if (bOpenNewForm) {
      ;(async () => {
        const response = await fnSetBShowFormTutorial()
        fnSetBIsOpenModalTutorial(!response?.data?.bvisualized)
      })()

      return
    }

    if (bIsFormManager) {
      ;(async () => {
        const response = await fnShowAutomationTutorialReq()
        fnSetBIsOpenModalTutorial(!response?.data?.opuat_bvisualized)
      })()
      return
    }

    return
  }, [bOpenNewForm, bIsFormManager])

  useEffect(() => {
    if (!bUpdateFormList) return
    ;(async () => {
      const response = await fnSubmitFormsList(nBoardId)
      fnSetAForms(response?.data)
      fnSetBUpdateFormList(false)
    })()
  }, [bUpdateFormList, panelId, nBoardId])

  useEffect(() => {
    ;(async () => {
      await fnGetCurrentPanel(panelId)
    })()
  }, [panelId])
  useEffect(() => {
    if (!oCurrentBoard) return
    fnSetCBoardName(location?.state?.cBoardName || oCurrentBoard?.name)

    if (newBoard || (oCurrentBoard?.board_model?.fields?.length === 1 && bCanChange)) {
      fnSetBModalModelActivityIsOpen(true)
    }
  }, [location?.state, oCurrentBoard, bCanChange, newBoard])

  useEffect(() => {
    if (
      !oBoardRes.done ||
      oBoardRes.loading ||
      oGetResponsiblesBoard.loading ||
      oGetResponsiblesBoard.done
    )
      return
    ;(async () => {
      //await fetchBlocksWithParams({ nBoardId })
      const response = await fnSubmitGetResponsiblesBoard(panelId, nBoardId)
      const oBoard = response?.data?.data?.length > 0 ? response?.data?.data[0] : null
      fnSetOCurrentBoard(oBoard)
    })()
  }, [oBoardRes, oGetResponsiblesBoard])

  useEffect(() => {
    if (!aBlocks?.length || oListBlocksPagination?.loading) return
    setTimeout(() => {
      searchHighlight(oParams.cSearchTerm)
    }, 10)
  }, [oParams, aBlocks, oListBlocksPagination])

  useEffect(() => {
    if (!oCreateBlock.done && !oCreateBlock.data?.length) return
    ;(async () => {
      await fetchBlocksWithParams({ nBoardId })
    })()
  }, [oCreateBlock])

  useEffect(() => {
    if (!oDeleteBlocks.done || !oDeleteBlocks.data) return
    ;(async () => {
      await fetchBlocksWithParams({ nBoardId })
    })()
  }, [oDeleteBlocks])

  useEffect(() => {
    if (!oMoveBlocks.done && !oMoveBlocks.data?.length) return
    ;(async () => {
      await fetchBlocksWithParams({ nBoardId })
    })()
  }, [oMoveBlocks])

  useEffect(() => {
    if (!oUpdateBlocks.done && !oUpdateBlocks.data?.length) return
    ;(async () => {
      await fetchBlocksWithParams({ nBoardId })
    })()
  }, [oUpdateBlocks])

  useEffect(() => {
    //ORDER BLOCKS UPDATE
    if (!oOrderBlockRes.done && !oOrderBlockRes.data?.length) return
    ;(async () => {
      await fetchBlocksWithParams({ nBoardId })
    })()
  }, [oOrderBlockRes])

  useEffect(() => {
    if (!oCreateActivityRes.done && !oCreateActivityRes.data?.length) return
    ;(async () => {
      fnSetBIsEditActivity(true)
      fnSetOcurrentActivity(oCreateActivityRes?.data?.data)
      await fnFetchActivitiesByBlock(oCreateActivityRes?.data?.data?.opat_opbl_nid)
    })()
  }, [oCreateActivityRes])

  useEffect(() => {
    if (
      !oMoveActivity.done &&
      !oMoveActivity.data &&
      !oMoveActivity.data?.data?.opat_opbl_nid
    )
      return
    ;(async () => {
      fnSetOparams({ bAppendToList: false, bPaginatedList: true, bUpdateList: false })
      await fnFetchActivitiesByBlock(oMoveActivity.data.data.opat_opbl_nid)
    })()
  }, [oMoveActivity]) // TEST NOT TO TREAT THE RELOAD ON FRONT

  useEffect(() => {
    if (!oCreateCommentRes.done && !oCreateCommentRes.data?.length) return
    ;(async () => {
      const response = await fnGetCommentsList(oCurrentActivity.opat_nid)
      fnSetAComments(response.data)
    })()
  }, [oCreateCommentRes])

  useEffect(() => {
    if (!oSubmitEvidence.done && !oSubmitEvidence.data?.length) return
    ;(async () => {
      const UpdateEvidenceList = await fnGetEvidencesList(oCurrentActivity?.opat_nid)
      fnSetAEvidences(UpdateEvidenceList.data.reverse())
    })()
  }, [oSubmitEvidence, oSubmitEditEvidence])

  useEffect(() => {
    if (!oSubmitEditEvidence.done && !oSubmitEditEvidence.data?.length) return
    ;(async () => {
      const UpdateEvidenceList = await fnGetEvidencesList(oCurrentActivity?.opat_nid)
      fnSetAEvidences(UpdateEvidenceList.data.reverse())
    })()
  }, [oSubmitEditEvidence])

  useEffect(() => {
    if (!oUpdateActivityRes.done && !oUpdateActivityRes.data?.length) return
    ;(async () => {
      fnHandleCloseActivityModal()
      fnSetOcurrentActivity(null)
      fnSetOparams({ bAppendToList: false, bPaginatedList: false, bUpdateList: false })
      await fnFetchActivitiesByBlock(oUpdateActivityRes.data.data.opat_opbl_nid)
    })()
  }, [oUpdateActivityRes])

  useEffect(() => {
    if (!oDeleteActivityRes.done || !oDeleteActivityRes.data) return
    ;(async () => {
      fnHandleCloseActivityModal()
      fnSetOparams({ bAppendToList: false, bPaginatedList: false, bUpdateList: false })
      await fnFetchActivitiesByBlock(
        oCurrentActivity?.blockID || oCurrentActivity?.opat_opbl_nid,
      )
      fnSetOcurrentActivity(null)
    })()
  }, [oDeleteActivityRes])

  useEffect(() => {
    if (!oChangeVisibilityFieldsRes.done && !oChangeVisibilityFieldsRes.data?.length)
      return
    ;(async () => {
      // fnSetOparams((prev) => ({ ...prev, bAppendToList: false, bPaginatedList: true }))
      await fetchBlocksWithParams({ nBoardId })
      await fnGetFields()
    })()
  }, [oChangeVisibilityFieldsRes])

  useEffect(() => {
    if (!oCreateActivityFieldRes.done && !oCreateActivityFieldRes.data?.length) return
    ;(async () => {
      const response = await fetchBlocksWithParams({ nBoardId })
      if (response?.lenght === undefined) return
      const aNnewCurrentBlockData =
        response &&
        response.find((block) => {
          if (block.opbl_nid === oCurrentBlock.opbl_nid) return block
          return
        })
      fnSetOCurrentBlock(aNnewCurrentBlockData)
    })()
  }, [oCreateActivityFieldRes])

  const oBoardTab = {
    id: nBoardId,
    label: location?.state?.cBoardName || oCurrentBoard?.name,
  }
  const cActionMessage = intl.get("BlocksPage.action_message")
  const bBoardObserver = !bCanChange
  async function fnSubmitCreateBlock(data) {
    await fnOCreateBlock(nBoardId, data)
    fnSetOparams({ bPaginatedList: true, bUpdateList: true })

    fnSetBModalIsOpen(false)
  }
  async function fnSubmitUpdateBlock(data) {
    await fnOUpdateBlocks(oBlock?.opbl_nid, data)
    fnSetOparams({ bPaginatedList: true, bUpdateList: true })
    fnSetBModalIsOpen(false)
  }
  async function fnMoveBlockSubmit() {
    if (nNewBlockMoveId === -1) return
    fnSetOparams({ bPaginatedList: true, bUpdateList: true })
    await fnOMoveBlocks(oBlockData?.opbl_nid, nNewBlockMoveId)
    fnSetBisMove(false)
  }

  async function fnHandleDeleteBlockSubmit(data) {
    const bCanSubmit = await fnCheckBlock(intl.get("BlocksPage.delete_block_error"))
    if (!bCanSubmit) {
      fnSetBIsDelete(false)
      fnSetBIsDeleteConfirmation(false)
      return
    }
    fnSetOparams({ bPaginatedList: true, bUpdateList: true })
    return await fnODeleteBlocks(oBlock?.opbl_nid, data)
  }

  async function fnReorderBlocksSubmit(nPositions) {
    fnSetABlocks([])
    await fnOOrderBlockReq(nBoardId, nPositions)
  }
  function fnSetBoardsToShow(oData) {
    aBoardsToShow = oData?.data?.boards?.filter((d) => {
      if (!fnIsObserver(nUserId, d.observers)) {
        return {
          id: d?.id,
          name: d?.name,
        }
      }
    })
  }

  async function fnMoveBoardSubmit() {
    const response = await fnFetchBoard(Number(panelId), nBoardId)
    const responseMoveBoard =
      response?.data?.data[0] &&
      (await fnSubmitMoveBoard(response?.data?.data[0], oBoardDataMove.id))
    responseMoveBoard.success && closeModalMoveAlert(false)
  }

  async function fnReorderActivitiesSubmit(nPositions, nblockId, bIsKanban = false) {
    const response = await fnReorderActivitiesReq(nblockId, nPositions)
    if (bIsKanban) {
      fnSetOparams({ bAppendToList: false, bPaginatedList: false, bUpdateList: false })
      await fnFetchActivitiesByBlock(nblockId)
    }
  }

  async function fnHandleModalMoveOpen() {
    const response = await fnSubmitGetPaineis("perPage=200")
    response.success && fnSetBisMove(true)
  }
  useLayoutEffect(() => {
    if (!aBlocks?.length) {
      fnSetNHeightAccordion(0)
      return
    }
    const initialWidth = document.getElementById("blankSpaceContent")?.clientHeight
    fnSetNHeightAccordion(initialWidth)
  }, [aBlocks])

  async function fnHandleUpdateBoardSubmit(data) {
    const response = await fnSubmitUpdateBoard(nBoardId, data)
    response.success && fnSetCBoardName(data?.name)
  }

  function fnHandleOpenModalConfirmationDeleteActivity() {
    fnSetBIsDeleteConfirmationActivity(true)
    fnSetBOpenActivyModal(false)
  }
  function fnHandleCancelModalConfirmationDeleteActivity() {
    fnSetBIsDeleteConfirmationActivity(false)
    fnSetBOpenActivyModal(true)
  }
  function fnHandleCloseModalDeleteActivity() {
    fnSetBIsDeleteActivity(false)
    fnSetBOpenActivyModal(true)
  }

  async function fnGetEvidencesList(nActivityId) {
    const response = await fnOGetEvidenceList(nActivityId)
    return response
  }
  async function fnGetCommentsList(nActivityId) {
    const response = await fnGetCommentsReq(nActivityId)
    return response
  }

  async function fnHandleModalEditActivitiesOpen(oActivity, oBlock) {
    fnSetOcurrentActivity(oActivity)
    fnSetOCurrentBlock(oBlock)
    fnSetBOpenActivyModal(true)
    fnSetBIsEditActivity(true)

    const validator = await fnSubmitGetPaineis("perPage=200")
    if (!validator.success) return
    const response = await fnGetEvidencesList(oActivity.opat_nid)
    const commentsList = await fnGetCommentsList(oActivity.opat_nid)
    fnSetAComments(commentsList.data)
    fnSetAEvidences(response.data)
  }

  async function fnMoveActivitySubmit(nActivityId, nBlockId, bBethelast) {
    if (nActivityId && nBlockId) {
      return await fnOMoveActivity(nActivityId, nBlockId, bBethelast)
    }

    if (nCurrentActivityMove === -1 || nNewBlockMoveId === -1) return
    await fnOMoveActivity(nCurrentActivityMove, nNewBlockMoveId, bBethelast)
    !oMoveActivity.loading && fnSetBIsMoveActivities(false)
    fnSetNNewBlockMoveId(-1)
    fnSetNcurrentActivityMove(-1)
  }

  async function fnDeleteActivitySubmit(data) {
    return await fnDeleteActivityReq(oCurrentActivity?.opat_nid, data)
  }

  function fnHandleDeleteBlock() {
    fnSetBIsDelete(true)
    fnSetBIsDeleteConfirmation(false)
  }
  function fnHandleDeleteActiviy() {
    fnSetBIsDeleteActivity(true)
    fnSetBIsDeleteConfirmationActivity(false)
  }
  function fnHandleDeleteBoardCancel() {
    fnSetBIsDeleteConfirmation(false)
  }

  async function fnCheckBlock(cErrorMessage) {
    const oCheckRegister = {
      nBlockId: oBlock?.opbl_nid,
      nBoardId: oBlock?.opbl_opbd_nid,
    }

    return await fnCheckRegister(oCheckRegister, cErrorMessage)
  }

  function fnCloseModalActivityModel() {
    fnSetBModalModelActivityIsOpen(false)
    if (newBoard) {
      fnNavigate(`/${panelId}/boards/${nBoardId}`)
    }
  }

  function fnCloseModaMoveBoard() {
    fnSetBisMove(false)
  }

  async function fnHandleDeleteBoardSubmit(data) {
    const response = await fnSubmitDeleteBoard(nBoardId, data)
    response?.success && fnToPanelPage()
    return response
  }

  async function fnOpenModalMoveActivity() {
    const response = await fnSubmitGetPaineis("perPage=200")
    fnSetBIsMoveActivities(true)
    fnSetBOpenActivyModal(false)
    fnSetNcurrentActivityMove(oCurrentActivity?.opat_nid)
  }

  function fnCloseModalEditActivity(data) {
    fnSetBIsMoveActivities(data)
    fnSetBOpenActivyModal(true)
    fnSetNcurrentActivityMove(-1)
  }

  function fnHandleOpenActivityModal(oCurrentBlock) {
    fnSetOCurrentBlock(oCurrentBlock)
    fnSetBOpenActivyModal(true)
    fnSetBWasOpenActivyModal(true)
    fnSetBIsEditActivity(false)
    oCurrentActivity && fnSetBOpenActivyModal(true)
  }

  function fnHandleCloseActivityModal() {
    fnSetBOpenActivyModal(false)
    fnSetBIsEditActivity(undefined)
    fnSetOcurrentActivity(null)
    fnResetEvidenceRes()
    fnSetBWasOpenActivyModal(false)
  }
  async function fnUpdateListBoards(panelId) {
    if (panelId === -1) return fnSetNNewBlockMoveId(-1)
    const response = await fnSubmitGetPainel(panelId)
    await fnSetBoardsToShow(response)
  }

  async function fnUpdateListBlocks(panelId) {
    if (panelId === -1) return fnSetNNewBlockMoveId(-1)
    await fnOListBlocksAccordion(panelId)
  }
  //Send Evidence
  async function fnSubmitEvidence(data) {
    const response = await fnSubmitEvidenceReq(oCurrentActivity?.opat_nid, data)
    return response
  }
  async function fnSubmitComment(data) {
    const response = await fnCreateCommentReq(oCurrentActivity?.opat_nid, data)
    return response
  }
  async function fnSubmitUpdateComment(nCommentId, data) {
    const response = await fnUpadteCommentReq(nCommentId, data)
    return response
  }
  async function fnDeleteComment(nCommentId) {
    const response = await fnDeleteCommentReq(nCommentId)
    return response
  }
  async function fnSubmitGetActivities(nBlockId) {
    const response = await fnGetActivitiesReq(nBlockId)
    return response
  }

  function fnHandleOpenHidenFields(oCurrenBlock) {
    if (oCurrenBlock?.opbl_nid) fnSetOCurrentBlock(oCurrenBlock)

    fnSetBopenCustomFields(true)

    fnSetBIsVisibleFieldsTable(false)
  }

  function fnHandleOpenCustomFields() {
    fnSetBModalModelActivityIsOpen(true)
  }

  function fnHandleCloseCustonFields() {
    fnSetBopenCustomFields(false)
    fnSetBIsVisibleFieldsTable(false)
    fnSetACheckedFields([])
    if (bWasOpenActivyModal || bIsEditActivity) return fnSetBOpenActivyModal(true)
  }

  const fnOnChangeSearchTerm = (cSearchTerm) => {
    fnSetOparams({ cSearchTerm, page: 1, bUpdateList: true })
  }

  function fnOpenModalNewCustomField() {
    fnSetBIsOpenModalNewCustomField(true)
    fnSetBopenCustomFields(false)
    // reset edit
    fnSetBOpeEditCustomField(false)
    fnSetOCustomField(null)
  }

  function fnCloseModalNewCustomField() {
    fnSetBIsOpenModalNewCustomField(false)
    fnSetBopenCustomFields(true)
    fnSetBIsVisibleFieldsTable(false)
  }

  async function fnSubmitNewCustomField(oData) {
    if (bOpeEditCustomField) {
      await fnUpdateField(oData)
      await fnRefreshCurrentBoard()
      oUpdateFieldRes.success && fnCloseModalNewCustomField()
      return
    }
    const response = await fnCreateActivityFielReq(oData)
    response.success && fnCloseModalNewCustomField()
  }

  const [nHeightAccordion, fnSetNHeightAccordion] = useState(0)
  const bShowButtonForm = aBlocks?.length ? true : false
  useEffect(() => {
    ;(async () => {
      if (aAllFields?.length > 0) return
      await fnGetFields()
    })()
  }, [oUpdateFieldRes])

  useEffect(() => {
    if (bIsEditActivity === false) {
      //criação atividade
      const oBoardModel = oCurrentBoard.board_model || oCurrentBoard.data[0].board_model
      const aFilteredCheckedFields = aAllFields?.filter((oField) => {
        const boardModelFields = oBoardModel?.fields?.some(
          (oFieldValue) => oFieldValue?.ombf_opfd_nid === oField?.opfd_nid,
        )
        if (boardModelFields) return oField
      })

      const aFormatedCheckedFields = aFilteredCheckedFields?.map((oField) => ({
        ...oField,
        opvf_bis_visible: true,
      }))
      //condition to fix checked field visibility after edition
      !aCheckedFields?.length && fnSetACheckedFields(aFormatedCheckedFields)

      return
    }
    if (oCurrentActivity) {
      const aFilteredCheckedFields = aAllFields?.filter((oField) => {
        const bFieldHasValue = oCurrentActivity?.values?.find(
          (oFieldValue) => oFieldValue?.opfv_opfd_nid === oField?.opfd_nid,
        )

        if (bFieldHasValue) return oField
      })
      const aFormatedCheckedFields =
        aFilteredCheckedFields?.map((oField) => ({
          ...oField,
          opvf_bis_visible: true,
        })) || []

      fnSetACheckedFields((prev) =>
        prev?.length ? [...prev, ...aFormatedCheckedFields] : aFormatedCheckedFields,
      )
      return
    }
    !bIsVisibleFieldsTable && fnSetACheckedFields(oCurrentBlock.fields)
  }, [oCurrentActivity, oCurrentBlock])

  useEffect(() => {
    if (!bOpenCustomFields) return
    if (!bIsVisibleFieldsTable) return
    const oCheckedFieldsFiltered = oCurrentBlock?.board_model?.fieldsName
    fnSetACheckedFields(oCheckedFieldsFiltered)
  }, [bOpenCustomFields, oCurrentBlock])

  const cUserTimezone = oUser?.data?.user_ctimezone || "America/Sao_Paulo"
  const aBreadCrumbs = [
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      path: "/",
      name: intl.get("DashboardPage.title"),
    },
    {
      path: `/${panelId}/boards`,
      name: oCurrentPanel?.name,
    },
    {
      name: cBoardName,
      bActive: true,
    },
  ]

  async function fnUpdateActivityBlocks(result) {
    if (!result.destination) return
    let nActivityId = Number(result.draggableId.split("-")[2])
    let nBlockId = Number(result.destination.droppableId.split("-")[1])
    let aTempBlocks = [...aBlocks]
    let selectedActivity
    let bActivityDone = false

    const fieldsNames = oCurrentBoard?.board_model?.fields.map((oField) => ({
      ...oField,
      opfd_nid: oField.ombf_opfd_nid,
      position: oField.ombf_nposition,
    }))

    aTempBlocks = aTempBlocks.map((oBlock) => {
      oBlock.name = oBlock.opbl_cname
      oBlock.id = oBlock.opbl_nid
      oBlock.fieldsName = fieldsNames

      // remove droped activity from old block
      if (oBlock.opbl_nid === Number(result.source.droppableId.split("-")[1])) {
        const oActivityPending = oBlock?.activities_pending?.find(
          (oActivity) => oActivity?.opat_nid == nActivityId,
        )

        if (oActivityPending) {
          bActivityDone = false
          selectedActivity = oActivityPending
          const aNewActivitiesPending = oBlock?.activities_pending?.filter(
            (a) => a?.opat_nid != nActivityId,
          )
          oBlock.activities_pending = aNewActivitiesPending
          oBlock.aData = aNewActivitiesPending
        } else {
          const oActivity = oBlock?.activities?.find(
            (oActivity) => oActivity?.opat_nid == nActivityId,
          )
          if (oActivity) {
            bActivityDone = true
            const aNewActivities = oBlock?.activities?.filter(
              (a) => a?.opat_nid != nActivityId,
            )
            selectedActivity = aNewActivities
            oBlock.activities = aNewActivities
            oBlock.aData = aNewActivities
          }
        }
        oBlock.total = oBlock.total - 1
        oBlock.bActivitiesLength =
          !oBlock?.activities?.length && !oBlock?.activities_pending?.length
        oBlock.nActivityLegth = oBlock?.activities?.length
          ? oBlock?.activities?.length
          : oBlock?.activities_pending?.length
      }

      return oBlock
    })

    // add droped activity to new block
    aTempBlocks = aTempBlocks?.map((oBlock) => {
      oBlock.name = oBlock.opbl_cname
      oBlock.id = oBlock.opbl_nid
      oBlock.fieldsName = fieldsNames

      if (oBlock?.opbl_nid === nBlockId) {
        if (bActivityDone) {
          oBlock?.activities?.splice(
            result.destination.index,
            0,
            ...([selectedActivity] || []),
          )

          const activities = oBlock?.activities?.map((activity) => ({
            ...activity,
            id: activity.opat_nid,
            originId: oBlock.opbl_nid,
          }))

          oBlock.aData = activities || []
          //return oBlock
        } else {
          oBlock?.activities_pending?.splice(
            result.destination.index,
            0,
            ...([selectedActivity] || []),
          )

          const activities_pending = oBlock?.activities_pending?.map((activity) => ({
            ...activity,
            id: activity.opat_nid,
            originId: oBlock.opbl_nid,
          }))

          oBlock.aData = activities_pending || []
        }

        oBlock.bActivitiesLength =
          !oBlock?.activities?.length && !oBlock?.activities_pending?.length
        oBlock.nActivityLegth = oBlock?.activities?.length
          ? oBlock?.activities?.length
          : oBlock?.activities_pending?.length
        oBlock.total = oBlock.total + 1
      }

      return oBlock
    })

    fnSetABlocks(aTempBlocks)
    return aTempBlocks
  }

  const oActivityTitleField = oCurrentBoard?.board_model?.fields?.find(
    (oField) => oField?.field?.opfd_cslug === cTitleSlug,
  )

  const cActivityTitle = oCurrentActivity?.values?.find(
    (oValue) => oValue?.opfv_opfd_nid === oActivityTitleField?.field?.opfd_nid,
  )?.opfv_cvalue

  async function fnGetAllBlocksToList() {
    await fnFetchBlocksToOrder(nBoardId)
  }

  async function fnHandleOnClickSortBlocks() {
    fnSetSortBlocks(bSortBlocks ? false : true)
    await fnGetAllBlocksToList()
  }

  async function fnSubmitModelBoard(nModelId, aData, callback) {
    try {
      const ModelBoard = oCurrentBoard.board_model || oCurrentBoard.data[0].board_model

      const currentModelFieldsIds = ModelBoard.fields.map((field) => field.ombf_opfd_nid)
      const oStatusField = aAllFields.find((field) => field.opfd_cslug === cStatusSlug)
      const oStatusIndex = aData.findIndex(
        (field) => field.ombf_opfd_nid === oStatusField.opfd_nid,
      )

      const tempACalcFields = []
      const regexField = /'([^']+)'/g
      const aCalcs = aData
        .filter((field) => field.ombf_cvalue)
        .map((field) => field.ombf_cvalue)
        .filter((field) => field.lenght > 0)
      aCalcs.forEach((field) => {
        const fieldsMatch = field.match(regexField)
        fieldsMatch &&
          fieldsMatch.forEach((match) => {
            match && tempACalcFields.push(Number(match.replace(/'/g, "")))
          })
      })
      // remova de aCalcFields os campos repetidos
      const aCalcFields = Array.from(new Set(tempACalcFields))

      aCalcFields.forEach((calcFieldId) => {
        if (
          !currentModelFieldsIds.includes(calcFieldId) &&
          !aData.map((item) => item.ombf_opfd_nid).includes(calcFieldId)
        ) {
          throw new Error("Field not found in model")
        }
      })

      //cheque o aData para ver se existe algum campo ombf_cvalue === [], caso haja substitua por aspas simples
      aData.forEach((field) => {
        if (typeof field.ombf_cvalue === "object") {
          field.ombf_cvalue = ""
        }
      })
      if (oStatusIndex > -1) {
        aData[oStatusIndex] = {
          ...aData[oStatusIndex],
          ombf_cvalue: undefined,
        }
      }

      const result = await fnUpdateBoardModel(nModelId, aData)
      await fnGetCurrentBoard(panelId, nBoardId)

      if (bOpenActivyModal && oCurrentActivity?.opat_nid) {
        const updatedActivityResponse = await fnSubmitGetActivities(
          oCurrentActivity.opat_nid,
        )
        fnSetOcurrentActivity(updatedActivityResponse?.data)
      }

      fnSetBModalModelActivityIsOpen(false)

      toast({
        type: "success",
        title: intl.get("BlocksPage.model_toast.success"),
        description: intl.get("BlocksPage.model_toast.success_message"),
      })

      if (newBoard) {
        fnNavigate(`/${panelId}/boards/${nBoardId}`)
      }

      return
    } catch (error) {
      toast({
        type: "error",
        title: intl.get("BlocksPage.model_toast.error"),
        description: intl.get("BlocksPage.model_toast.error_message"),
      })
      fnSetBCalModalError(true)
      callback()
      return
    }
  }

  function fnToastFailDuplicate() {
    return toast({
      type: "error",
      title: intl.get("table_fields.toast.fail"),
      description: intl.get("CardBoard.modal.toast_message_error"),
    })
  }

  function fnOpenModalDuplicateBoard(data) {
    fnSetBIsOpenModalDuplicate(true)
  }

  function fnOnCloseDuplicateModal() {
    fnSetBIsOpenModalDuplicate(false)
  }

  async function fnHandleConfirmDuplicateBoard(e) {
    e.stopPropagation()
    e.preventDefault()
    const response = await fnSubmitDuplicateBoardReq(nBoardId)
    if (response.success) {
      fnSetBIsOpenModalDuplicate(false)
      return
    }
    fnSetBIsOpenModalDuplicate(false)
    fnToastFailDuplicate()
  }

  function ElButtonOpenCustomFieldsModal() {
    if (!bCanChange) return null
    return (
      <Button
        variant="outline"
        iconLeft={<GearIcon />}
        onClick={() => fnSetBModalModelActivityIsOpen(true)}
        disabled={bSortBlocks}
        style={{
          textTransform: "uppercase",
        }}
      >
        {intl.get("BlocksPage.custom_fields")}
      </Button>
    )
  }

  function ElViewForms({ key }) {
    return (
      <>
        {bShowButtonForm && (
          <Button
            key={key}
            variant="outline"
            onClick={() => fnOpenModalFormManagement()}
            iconLeft={"penDocumentIcon"}
          >
            {intl.get("BlocksPage.new_form")}
          </Button>
        )}
      </>
    )
  }

  function ElViewAutomation({ key }) {
    return (
      <>
        {bShowButtonForm && (
          <Button
            key={key}
            variant="outline"
            onClick={() => fnOpenModalAutomationManagement()}
            iconLeft={"RcmpAutomationIcon"}
          >
            {intl.get("BlocksPage.automation")}
          </Button>
        )}
      </>
    )
  }

  async function fnHandleExport() {
    const total = aBlocksASortedOrder.reduce((sum, block) => sum + block.total, 0)
    if (total > 1500) {
      fnSetBModalCantExportIsOpen(true)
      return
    }
    const response = await fnGetBoardExportReq(nBoardId, aFilters)
    const logoUser = await fnGetCustomerLogoReq()
    fnHandleExportToXlsx(
      oCurrentBoard,
      cUserTimezone,
      response.data,
      oUser,
      logoUser.cust_clogo,
      nBlockViewMode,
    )
  }

  function fnCloseWarningExport() {
    fnSetBModalCantExportIsOpen(false)
    fnSetBModalExportActivityIsOpen(false)
  }
  function fnCloseWarningQrCodeError() {
    fnSetOOpenModalErrorQrCode({ bIsOpen: false, blockType: "" })
    window.location.href = "/"
  }
  function fnOpenModalFormManagement(oForm) {
    fnFormListReset()
    fnSetBIsFormMager(false)
    fnSetBOpenModalList(true)
  }
  function fnCloseFormManagement() {
    fnSetBOpenModalList(false)
    fnSetBIsFormMager(false)
    fnSetAAutomation([])
  }
  function fnOpenModalAutomationManagement() {
    fnSetBIsFormMager(true)
    fnSetBOpenModalList(true)
  }

  function fnCloseModalTutorial() {
    if (bVisualizedTutorialModal && !bIsFormManager) {
      fnSetHiddentTutorialModal()
    }
    if (bVisualizedTutorialModal && bIsFormManager) {
      fnSetBHidenAutomationTutorialReq()
    }
    fnSetBIsOpenModalTutorial(false)
  }

  const bHasFieldsInBoardModel = oCurrentBoard?.board_model?.fields?.length > 1

  useEffect(() => {
    const haveViewMode = JSON.parse(localStorage.getItem("blocksViewMode") || "[]")
    const existingBlockId = haveViewMode.find((board) => board.blockId === nBoardId)
    if (existingBlockId) {
      fnSetnBlockViewMode(existingBlockId.viewMode)
    } else {
      fnSetnBlockViewMode(0)
    }
  }, [nBoardId])

  async function fnChangeBlocksView(data) {
    const bCollumnOrder = JSON.parse(localStorage.getItem("columnOrder"))
    fnSetnBlockViewMode((prev) => {
      if (prev === 0 && data === 1 && bCollumnOrder.length > 0) {
        localStorage.setItem("columnOrder", JSON.stringify([]))
        fetchBlocksWithParams({ nBoardId })
        return data
      }
      return data
    })
    const viewMode = JSON.parse(localStorage.getItem("blocksViewMode") || "[]")
    const existingBlockId = viewMode.find((board) => board.blockId === nBoardId)
    if (existingBlockId) {
      existingBlockId.viewMode = data
    } else {
      viewMode.push({ blockId: nBoardId, viewMode: data })
    }
    localStorage.setItem("blocksViewMode", JSON.stringify(viewMode))
  }

  const fnHandleHiddenBlockFields = (oSelectedBlock) => {
    const aUpdatedBlocks = aBlocks.map((oBlock) => {
      if (oBlock.opbl_nid === oSelectedBlock.opbl_nid) {
        oBlock[nBlockViewMode === 0 ? "table_hidden_fields" : "kanban_hidden_fields"] =
          oSelectedBlock?.hidden_fields
      }
      return oBlock
    })
    fnSetABlocks(aUpdatedBlocks)
    fnHandleCloseCustonFields()
  }

  if (bIsQrCodeActivity && !bOpenActivyModal) {
    return (
      <div className={styles.loadingQrCode}>
        <RcmpLoading bShow={true} />
        <RcmpModalInfo
          bIsOpen={oOpenModalErrorQrCode.bIsOpen}
          title={intl.get("warning")}
          description={
            oOpenModalErrorQrCode.blockType === "denied_module"
              ? intl.get("BlocksPage.cannot_access_module")
              : intl.get("BlocksPage.cannot_access_page")
          }
          size="sm"
          buttonSaveText={intl.get("close")}
          oButtonSaveProps={{ style: { margin: "0 auto" } }}
          oButtonCancelProps={{ style: { display: "none" } }}
          fnHandleConfirm={fnCloseWarningQrCodeError}
          fnHandleCancel={fnCloseWarningQrCodeError}
        />
      </div>
    )
  }
  return (
    <div>
      <RcmpHeader
        cTitlePage={intl.get("BlocksPage.title")}
        aBreadCrumbs={aBreadCrumbs}
        className={styles.hideHeaderTitle}
      >
        <div className={styles.headerContaienr}>
          <RcmpBackPageButton onClick={fnToPanelPage} />
          <Tab tab={oBoardTab} style={{ marginLeft: 0 }} />
        </div>
      </RcmpHeader>
      <ContentBlank
        sButtonLabel={intl.get("BlocksPage.new_block")}
        aEllipsisContent={
          bBoardObserver
            ? []
            : nBlockViewMode === 1
            ? [...aCardOptions.slice(0, 6)]
            : aCardOptions
        }
        fnSetBisOpenModal={bBoardObserver || !bCanChange ? null : fnSetBModalIsOpen}
        bSwitchable={true}
        setSearchTerm={fnOnChangeSearchTerm}
        fnOnChangeSwitch={fnSetOparams}
        nEizeEllipsis={"210px"}
        bShowButtonForm={bShowButtonForm}
        bDisableActions={bSortBlocks}
        bCanShowActions={bCanChange}
        nBlockViewMode={nBlockViewMode}
        fnChangeBlocksView={fnChangeBlocksView}
        bChangeViewMode={true}
        customButtons={
          bCanChange && bHasFieldsInBoardModel
            ? [
                <ElButtonOpenCustomFieldsModal key={0} />,
                <ElViewAutomation key={2} />,
                <ElViewForms key={1} />,
              ]
            : bCanChange
            ? [<ElButtonOpenCustomFieldsModal key={0} />]
            : []
        }
        bShowFilter
      >
        <div className={styles.blockListContainer}>
          {aBlocks?.length > 0 && !bIsQrCodeActivity && (
            <DragDropContextProvider>
              {!bIsQrCodeActivity && (
                <RcmpBlocksList
                  ref={painelRef}
                  aData={aBlocks}
                  bFIlterActivities={oParams.bDone || aFilters?.length > 0}
                  fnDeleteBlock={fnSetBIsDeleteConfirmation}
                  fnSetCBlockName={fnSetOBlock}
                  fnSetBisEdit={fnSetBisEdit}
                  fnSetBModalIsOpen={fnSetBModalIsOpen}
                  fnHandleModalMoveOpen={fnHandleModalMoveOpen}
                  fnSetABlockData={fnSetOBlockData}
                  oBlockData={oBlockData}
                  fnAddActivity={fnHandleOpenActivityModal}
                  fnHandleModalEditActivity={fnHandleModalEditActivitiesOpen}
                  bObserver={bHasFieldsInBoardModel ? bBoardObserver : true}
                  fnReorderActivitiesSubmit={fnReorderActivitiesSubmit}
                  oReorderActivitiesRes={oReorderActivitiesRes}
                  fnSubmitGetActivities={fnSubmitGetActivities}
                  oGetActivitiesRes={oGetActivitiesRes}
                  fnOpenCustomFields={fnHandleOpenHidenFields}
                  nHeightAccordion={nHeightAccordion}
                  fnReorderBlocksSubmit={fnReorderBlocksSubmit}
                  fnMoveActivitySubmit={fnMoveActivitySubmit}
                  fnUpdateActivityBlocks={fnUpdateActivityBlocks}
                  aAllFields={aAllFields}
                  fnSetSortBlocks={fnSetSortBlocks}
                  bSortBlocks={bSortBlocks}
                  oOrderBlockRes={oOrderBlockRes}
                  oCurrentBoard={oCurrentBoard}
                  bCanChangeBlock={bCanChange}
                  fnSetBIsVisibleFieldsTable={fnSetBIsVisibleFieldsTable}
                  bIsObserverBoard={bIsObserver}
                  oCurrentModel={
                    oCurrentBoard?.board_model ||
                    oCurrentBoard?.data[0]?.board_model ||
                    null
                  }
                  nBlockViewMode={nBlockViewMode}
                  oMoveActivity={oMoveActivity}
                  fnReorderActivitiesReq={fnReorderActivitiesReq}
                  fnSetBModalModelActivityIsOpen={fnSetBModalModelActivityIsOpen}
                />
              )}
            </DragDropContextProvider>
          )}
        </div>
        {!oListBlocksPagination?.loading && (
          <RcmpEmptyContentPage
            bShow={!oListBlocksPagination.loading && !aBlocks?.length}
            cMessage={
              oParams?.cSearchTerm?.length
                ? intl.get("BlocksPage.no_search_activity_block_message")
                : intl.get("BlocksPage.no_activity_block_message")
            }
            cActionMessage={cActionMessage}
            bShowAction={bCanChange}
            cQuestion={intl.get("BlocksPage.what_is_a_block")}
            cAnswer={intl.get("BlocksPage.block_answer")}
            image={noBlocksImage}
            fnOnAction={fnSetBModalIsOpen}
          />
        )}
        <RcmpLoading
          bShow={oListBlocksPagination?.loading || bIsQrCodeActivity ? true : false}
        />
      </ContentBlank>

      <RcmpModalAddBlock
        bIsOpen={bModalIsOpen}
        fnOnClose={fnSetBModalIsOpen}
        cTitle={
          bIsEdit
            ? intl.get("BlocksPage.edit_block_name", { block: oBlock?.opbl_cname })
            : intl.get("BlocksPage.new_block_modal")
        }
        fnHandleConfirm={fnSubmitCreateBlock}
        bIsEdit={bIsEdit}
        fnHandleSubmitEdit={fnSubmitUpdateBlock}
        fnSetBisEdit={fnSetBisEdit}
        cPrevData={oBlock?.opbl_cname}
        oBlockRes={bIsEdit ? oUpdateBlocks : oCreateBlock}
        oBlock={oBlock}
      />
      <RcmpModalInfo
        bIsOpen={bIsDeleteConfirmation || bIsDeleteConfirmationActivity}
        buttonCancelText={intl.get("cancel")}
        buttonSaveText={intl.get("continue")}
        title={
          bIsDeleteConfirmation
            ? intl.get("BlocksPage.delete_block")
            : intl.get("BlocksPage.delete_activity")
        }
        description={intl.get("BlocksPage.operation_cannot_be_undone")}
        size={"sm"}
        fnHandleCancel={
          bIsDeleteConfirmation
            ? fnHandleDeleteBoardCancel
            : fnHandleCancelModalConfirmationDeleteActivity
        }
        fnHandleConfirm={
          bIsDeleteConfirmation ? fnHandleDeleteBlock : fnHandleDeleteActiviy
        }
      />
      <ModalConfirmDelete
        fnOnClose={fnSetBIsDelete}
        fnHandleDelete={fnHandleDeleteBlockSubmit}
        bOnDelete={bIsDelete}
        isOpen={bIsDelete}
        headerText={intl.get("BlocksPage.delete_block")}
        fnSetBDelete={fnSetBIsDelete}
        text={intl.get("BlocksPage.sure_to_delete_block", {
          block: oBlock?.opbl_cname,
        })}
      />
      <ModalConfirmDelete
        fnOnClose={fnHandleCloseModalDeleteActivity}
        fnHandleDelete={fnDeleteActivitySubmit}
        bOnDelete={bIsDeleteActivity}
        isOpen={bIsDeleteActivity}
        headerText={intl.get("BlocksPage.delete_activity")}
        fnSetBDelete={bIsDeleteActivity}
        text={intl.get("BlocksPage.sure_to_delete_activity", {
          activity: cActivityTitle || oCurrentActivity?.opat_nid,
        })}
      />
      <RcmpModalMove
        cTitle={intl.get("BlocksPage.move_block")}
        bIsOpen={bIsMove}
        bOnClose={fnCloseModaMoveBoard}
        oGetData={oGetPaineis?.data?.data?.data}
        cInfoText={intl.get("modal_move.select_destination")}
        nCurrentId={-1}
        bCollapse={true}
        fnGetDataPanel={fnUpdateListBoards}
        aSubData={
          !oGetPainel?.loading && oGetPainel?.done ? (
            <RcmpAccordionSubItem
              data={oGetPainel?.data?.data?.boards}
              fnSetSubitem={fnSetNNewBlockMoveId}
              nCurrentId={nBoardId}
            />
          ) : (
            <RcmpLoading bShow={!oGetPaineis?.loading} size={20} />
          )
        }
        subDataId={fnSetNNewBlockMoveId}
        fnSubmitMove={fnMoveBlockSubmit}
      />
      {bOpenActivyModal && (
        <RcmpModalAddActivity
          bIsOpen={bOpenActivyModal}
          fnOnClose={fnHandleCloseActivityModal}
          fnOpenModalMoveActivity={fnOpenModalMoveActivity}
          bIsEdit={bIsEditActivity}
          fnCreateActivity={fnCreateActivityReq}
          fnUpdateActivity={fnUpdateActivityReq}
          oActivityRes={bIsEditActivity ? oUpdateActivityRes : oCreateActivityRes}
          oCurrentBlock={oCurrentBlock}
          oCurrentActivity={oCurrentActivity}
          fnSetOCurrentActivity={fnSetOcurrentActivity}
          fnSetBIsDeleteActivity={fnHandleOpenModalConfirmationDeleteActivity}
          fnSetBopenCustomFields={fnHandleOpenCustomFields}
          bCanChange={bCanChange}
          fnSubmitEvidence={fnSubmitEvidence}
          fnSubmitComment={fnSubmitComment}
          fnDeleteComment={fnDeleteComment}
          oCreateCommentRes={oCreateCommentRes}
          fnSubmitUpdateComment={fnSubmitUpdateComment}
          fnSubmitGetActivities={fnSubmitGetActivities}
          aEvidences={aEvidences || oGetEvidenceList?.data?.data}
          fnSetAEvidences={fnSetAEvidences}
          aCommentsList={aComments}
          fnSetAComments={fnSetAComments}
          oSubmitEvidence={oSubmitEvidence}
          bReadOnly={!bIsResponsibleCurrentActivity}
          fnEditEvidenceSubmit={fnSubmitEditEvidenceReq}
          fnSetOparams={fnSetOparams}
        />
      )}
      <RcmpModalMove
        cTitle={intl.get("BlocksPage.move_activity")}
        bIsOpen={bIsMoveActivities}
        bOnClose={fnCloseModalEditActivity}
        oGetData={oGetPaineis?.data?.data?.data}
        cInfoText={intl.get("modal_move.select_destination")}
        bCollapse={true}
        fnGetDataPanel={fnUpdateListBoards}
        aSubData={
          !oGetPainel?.loading && oGetPainel?.done ? (
            <RcmpAccordion
              oGetData={aBoardsToShow}
              bCollapse={true}
              fnGetSubData={fnUpdateListBlocks}
              fnSetId={fnUpdateListBlocks}
              fnSetData={fnUpdateListBlocks}
              subDataId={fnUpdateListBlocks}
            >
              {!oListBlocksAccordion.loading ? (
                <RcmpAccordionSubItem
                  data={oListBlocksAccordion?.data?.data?.data}
                  fnSetSubitem={fnSetNNewBlockMoveId}
                  aPropsToMap={["opbl_cname", "opbl_nid"]}
                />
              ) : (
                <RcmpLoading bShow={!oGetPaineis?.loading} size={20} />
              )}
            </RcmpAccordion>
          ) : (
            <RcmpLoading bShow={!oGetPaineis?.loading} size={20} />
          )
        }
        subDataId={fnSetNNewBlockMoveId}
        fnSubmitMove={fnMoveActivitySubmit}
      />
      {bOpenCustomFields && (
        <RcmpModalHideFields
          bIsOpen={bOpenCustomFields}
          buttonCancelText={intl.get("cancel")}
          buttonSaveText={intl.get("save_changes")}
          title={intl.get("BlocksPage.hide_fields")}
          textHead={intl.get("BlocksPage.select_visible_fields")}
          fnHandleCancel={fnHandleCloseCustonFields}
          fnHandleConfirm={fnHandleHiddenBlockFields}
          oCurrentBlock={oCurrentBlock}
          nBlockViewMode={nBlockViewMode}
        />
      )}
      <RcmpModalCreateNewCustomField
        bIsOpen={bIsOpenModalNewCustomField}
        fnCancel={fnCloseModalNewCustomField}
        fnHandleConfirm={fnSubmitNewCustomField}
        oCreateActivityFieldRes={oCreateActivityFieldRes}
        bIsEdit={bOpeEditCustomField}
        oField={oCustomField}
      />
      <RcmpModalsBoardChange
        ///////////create and edit modal
        fnHandleCancel={fnCloseModalEditBoard}
        nCardId={oCurrentBlock?.data?.opbl_opbd_nid}
        aNorms={aNorms}
        bIsOpen={bIsOpenModalEditBoard}
        fnHandleUpdateBoardSubmit={fnHandleUpdateBoardSubmit}
        bIsEdit={bIsOpenModalEditBoard}
        schema={schema}
        aBoardData={aBoardData}
        fnSetABoadData={fnSetABoadData}
        ///////////delete
        fnSetBDeleteBoardConfirmation={fnCloseModalDeleteBoard}
        fnHandleDeleteBoardSubmit={fnHandleDeleteBoardSubmit}
        bDeleteBoardConfirmation={bIsOpenModalDeleteBoard}
        bDeleteBoard={bIsOpenModalDeleteBoardAlert}
        cNameBoard={cBoardName}
        ///////delete alert
        fnHandleDeleteBoardCancel={fnCloseModalDeleteBoard}
        fnHandleDeleteBoard={fnOpenModalDeleteBoard}
        ////interaction
        bOpenInteractions={bIsOpenModalInteractionsBoard}
        fnSetBOpenInteractions={fnSetBIsOpenModalInteractionsBoard}
        oSelectedBoard={{ name: cBoardName, id: nBoardId }}
        ///Move
        bIsMove={bIsOpenModalMoveBoard}
        fnCloseModaMoveBoard={() => fnSetIsOpenModalMoveBoard(false)}
        oGetPaineis={oGetPaineis?.data?.data?.data}
        panelId={panelId}
        fnHandleModalInfo={fnHandleModalMoveAlert}
        fnSetOBoardDataMove={fnSetOBoardDataMove}
        /// move alert modal
        bModalInfo={bIsOpenModalMoveAlertBoard}
        fnSetBModalInfo={closeModalMoveAlert}
        fnMoveBoardSubmit={fnMoveBoardSubmit}
        oCurrentPanel={oCurrentPanel}
        oBoardDataMove={oBoardDataMove}
        ///duplicate
        fnOnCloseDuplicateModal={fnOnCloseDuplicateModal}
        bIsOpenDubplicate={bIsOpenModalDuplicate}
        fnHandleConfirmDuplicateBoard={fnHandleConfirmDuplicateBoard}
      />
      <RcmpModalActivityModel
        bIsOpen={bModalModelActivityIsOpen}
        fnOnClose={fnCloseModalActivityModel}
        fnCancel={fnSetBModalModelActivityIsOpen}
        fnOpenModalNewCustomField={fnOpenModalNewCustomField}
        fnSubmit={fnSubmitModelBoard}
      />
      {bOpenModalList && (
        <RcmpModalList
          bIsOpen={bOpenModalList}
          bOnClose={() => fnCloseFormManagement()}
          aBlocks={aBlocks}
          oCurrentBoard={oCurrentBoard}
          aData={!bIsFormManager ? aForms : aAutomation}
          aAutomations={[]}
          bIsAutomation={bIsFormManager}
          title={
            bIsFormManager
              ? intl.get("modal_automation_list.automation_management")
              : intl.get("modal_form_list.forms_manager")
          }
          cCreateNewFunctionality={
            !bIsFormManager
              ? intl.get("modal_form_list.new_form")
              : intl.get("modal_automation_list.new_automation")
          }
          fnOpenModalNewFunctionality={
            !bIsFormManager ? fnOpenNewForm : fnOpenNewAutomation
          }
          bDataLoadingRequest={!bIsFormManager ? oFormsList.done : oAutomationList.done}
          bCanChange={bCanChange}
          fnGetHistory={fnAutomationHistoryReq}
        />
      )}

      {bOpenNewForm && (
        <RcmpModalNewForm
          bIsOpen={bOpenNewForm}
          bIsEdit={bIsEditForm}
          bShareForm={bShareForm}
          oForm={oForm}
          aBlocks={aBlocks}
          fnOnClose={fnCloseNewForm}
          oCurrentBoard={oCurrentBoard}
        />
      )}
      {bOpenNewAutomation && (
        <RcmpModalNewAutomation
          bIsOpen={bOpenNewAutomation}
          bShareForm={bShareAutomation}
          bIsEdit={false}
          oAutomation={{}}
          aBlocks={aBlocksToOrder}
          fnOnClose={fnCloseNewAutomation}
          oCurrentBoard={oCurrentBoard}
          fnGetAllBlocksToList={fnGetAllBlocksToList}
          nBoardId={nBoardId}
          oCreateBlock={oCreateBlock}
        />
      )}

      {bIsOpenModalTutorial && (
        <RcmpTutorialModal
          bIsOpen={bIsOpenModalTutorial}
          cMessage={
            bIsFormManager ? (
              <span>
                {intl.get("modal_info_automation.message")}
                <strong>
                  <BrandTitle />
                </strong>
                {intl.get("modal_info_automation.message_end")}
              </span>
            ) : (
              intl.get("modal_info_form.message")
            )
          }
          cHeaderText={
            bIsFormManager
              ? intl.get("modal_info_automation.header")
              : intl.get("modal_info_form.header")
          }
          fnOnClose={fnCloseModalTutorial}
          onChange={fnSetBVisualizedTutorialModal}
        />
      )}

      <RcmpModalExport
        fnHandleCancel={fnToggleExportModalIsOpen}
        bIsOpen={bModalExportActivityIsOpen}
        title={"Exportar"}
        fnHandleExportToXlsx={() => fnHandleExport()}
        fnHandleExportToPdf={() => fnHandleExportToPdf(aBlocks)}
        oGetBoardExportRes={oGetBoardExportRes}
      />
      <RcmpModalInfo
        bIsOpen={bCalcModelError}
        onlyCancel={true}
        title={"Erro"}
        fnHandleCancel={() => fnSetBCalModalError(false)}
        buttonCancelText={intl.get("cancel")}
        description="Revise os valores lançados nos campos de origem!"
      />
      <RcmpModalInfo
        bIsOpen={bCalcModelError}
        title={"Erro"}
        fnHandleCancel={() => fnSetBCalModalError(false)}
        buttonCancelText={intl.get("cancel")}
        description="Revise os valores lançados nos campos de origem!"
      />
      <RcmpModalInfo
        bIsOpen={bModalCantExportIsOpen}
        title={intl.get("warning")}
        description={intl.get("BlocksPage.canot_export_board")}
        size="sm"
        buttonSaveText="OK"
        oButtonSaveProps={{ style: { margin: "0 auto" } }}
        oButtonCancelProps={{ style: { display: "none" } }}
        fnHandleConfirm={fnCloseWarningExport}
        fnHandleCancel={fnCloseWarningExport}
      />
    </div>
  )
}
